/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Service_InstantInputs */

const en_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Delivery`)
};

const es_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega instantánea`)
};

const fr_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison instantanée`)
};

const de_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sofortige Lieferung`)
};

const ja_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即時提供`)
};

const zh_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即时交付`)
};

const ar_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم فوري`)
};

const id_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman Instan`)
};

const it_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consegna Istantanea`)
};

const ru_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мгновенная доставка`)
};

const pt_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega Imediata`)
};

const ko_fulfillment_service_instant = /** @type {(inputs: Fulfillment_Service_InstantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`즉시 제공`)
};

/**
* | output |
* | --- |
* | "Instant Delivery" |
*
* @param {Fulfillment_Service_InstantInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_service_instant = /** @type {((inputs?: Fulfillment_Service_InstantInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Service_InstantInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_service_instant(inputs)
	if (locale === "es") return es_fulfillment_service_instant(inputs)
	if (locale === "fr") return fr_fulfillment_service_instant(inputs)
	if (locale === "de") return de_fulfillment_service_instant(inputs)
	if (locale === "ja") return ja_fulfillment_service_instant(inputs)
	if (locale === "zh") return zh_fulfillment_service_instant(inputs)
	if (locale === "ar") return ar_fulfillment_service_instant(inputs)
	if (locale === "id") return id_fulfillment_service_instant(inputs)
	if (locale === "it") return it_fulfillment_service_instant(inputs)
	if (locale === "ru") return ru_fulfillment_service_instant(inputs)
	if (locale === "pt") return pt_fulfillment_service_instant(inputs)
	return ko_fulfillment_service_instant(inputs)
});